export default "__VITE_ASSET__0DcAQVsH__"